import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useLang } from "../i18n";

const CALENDAR = "https://calendar.app.google/8KcM5D1CsCiiFJDy6";

const lines = [
  { cmd: "mail", label: "aliidrees8600@gmail.com", href: "mailto:aliidrees8600@gmail.com" },
  { cmd: "git", label: "github.com/ali8600", href: "https://github.com/ali8600" },
  { cmd: "linkedin", label: "linkedin.com/in/aliidrees-cs", href: "https://www.linkedin.com/in/aliidrees-cs/" },
];

function Contact() {
  const { t } = useLang();
  const [status, setStatus] = useState("idle");

  const onSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);
    if (data.get("_honey")) {
      setStatus("sent");
      form.reset();
      return;
    }
    setStatus("sending");
    try {
      const response = await fetch("https://formsubmit.co/ajax/aliidrees8600@gmail.com", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          name: data.get("name"),
          email: data.get("email"),
          message: data.get("message"),
          _replyto: data.get("email"),
          _subject: `Portfolio — ${data.get("name")}`,
          _template: "table",
          _captcha: "false",
        }),
      });
      if (!response.ok) throw new Error(String(response.status));
      form.reset();
      setStatus("sent");
    } catch {
      setStatus("error");
    }
  };

  return (
    <div className="relative flex min-h-dvh flex-col">
      <Header />
      <main className="mx-auto w-full max-w-[760px] flex-1 px-5 pb-20 pt-10 sm:px-8">
        <div className="section-label">
          <h1>{t.contact.heading}</h1>
        </div>
        <p className="contact-intro">{t.contact.intro}</p>
        <a className="btn btn-primary contact-book" href={CALENDAR} target="_blank" rel="noopener noreferrer">
          {t.contact.book}
        </a>

        <form className="contact-form" onSubmit={onSubmit}>
          <label>
            {t.contact.name}
            <input name="name" type="text" required autoComplete="name" />
          </label>
          <label>
            {t.contact.email}
            <input name="email" type="email" required autoComplete="email" />
          </label>
          <label>
            {t.contact.message}
            <textarea name="message" required rows={5} />
          </label>
          <input className="contact-honey" type="text" name="_honey" tabIndex={-1} autoComplete="off" aria-hidden="true" />
          <button className="btn btn-primary" type="submit" disabled={status === "sending"}>
            {status === "sending" ? t.contact.sending : t.contact.send}
          </button>
          {status === "sent" || status === "error" ? (
            <p className="contact-status" role="status">{t.contact[status]}</p>
          ) : null}
        </form>

        <div className="contact-list">
          {lines.map((line) => (
            <a
              key={line.cmd}
              href={line.href}
              className="contact-line"
              {...(line.href.startsWith("http") ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            >
              <span className="prompt">$</span>
              <span className="text-muted">{line.cmd}</span>
              <span className="break-all">{line.label}</span>
            </a>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Contact;
